import { render } from "./SliderComponentSecond.vue?vue&type=template&id=2ac0d995&scoped=true"
import script from "./SliderComponentSecond.vue?vue&type=script&lang=js"
export * from "./SliderComponentSecond.vue?vue&type=script&lang=js"

import "./SliderComponentSecond.vue?vue&type=style&index=0&id=2ac0d995&scoped=true&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac0d995"]])

export default __exports__